export default __webpack_public_path__ + "static/media/Resume.40518e4a.pdf";